import { getField, updateField } from 'vuex-map-fields'
import getClientFiltersModel from './models/clientFilters'

const clientFilters = {
  namespaced: true,
  state: {
    ...getClientFiltersModel()
  },
  getters: {
    getField,
    getSearchObject: (state) => {
      return state
    }
  },
  mutations: {
    updateField,
    clearFilters: (state) => {
      state.businessEntityId = null
      state.name = null
      state.active = true
      state.invoiceFrequencyId = null
      state.thirdPartyPortalId = null
    }
  },
  actions: {
    clearFilters: ({ commit }) => {
      return commit('clearFilters')
    }
  }
}

export default clientFilters
